import React, { useEffect, useState } from "react";
import { createGenericContext } from "../../utils/createGenericContext";
import { getCookie, setCookie } from "../../utils/cookies";
import { GlossaryTerm } from "./types";
import contentService from "../../services/content-service";

export interface IGlossaryContext {
  terms: GlossaryTerm[];
  enabled: boolean;
  loaded: boolean;
  toggleEnabled: () => void;
}

const [useGlossary, GlossaryContextProvider] =
  createGenericContext<IGlossaryContext>(
    "useGlossary must be used within a GlossaryProvider"
  );

const COOKIE_NAME = "kd-glossary";
const COOKIE_EXPIRY_MINUTES = 525600; // 1 year

const GlossaryProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [terms, setTerms] = useState<GlossaryTerm[]>([]);
  const [enabled, setEnabled] = useState<boolean>(
    getCookie(COOKIE_NAME) !== "off"
  );
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    contentService
      .getGlossary()
      .then((res) => {
        setTerms(res.data);
        setLoaded(true);
      })
      .catch(() => {
        setLoaded(true);
      });
  }, []);

  const toggleEnabled = () => {
    const newValue = !enabled;
    setEnabled(newValue);
    setCookie(COOKIE_NAME, newValue ? "on" : "off", COOKIE_EXPIRY_MINUTES);
  };

  return (
    <GlossaryContextProvider
      value={{ terms, enabled, loaded, toggleEnabled }}
    >
      {children}
    </GlossaryContextProvider>
  );
};

export { useGlossary, GlossaryProvider };
